export default __webpack_public_path__ + "static/media/learose4-1920w.b11b1219.png";